export const assign_reviewers = {
  Edit_steps: "Edit steps",
  New_group_name: "New group name",
  Previously_created_groups: "Previously created groups",
  Save_this_group: "Save this group",
  Selected_Theme: "Selected Theme",
  Steps: "Steps",
} as const;
